<template>
     <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner />
    </b-container>
    <b-container v-else>
        
        <router-link class="admin-link"
            :to="{ path: `/Admin/StandardBooks`, query: { 'api-Version': apiHeaders['api-Version'] } }"
        >
            &larr; Перейти к списку книг стандартов
        </router-link>

        <b-row>
            <b-col class="pt-38">
                <span class="admin-title">{{header}}</span>
            </b-col>
            <b-col>
                <b-img right 
                       thumbnail fluid 
                       rounded="circle" 
                       style="height: 80px;" 
                       :src="setImage"/>  
            </b-col>
        </b-row>
        <hr class="my-4">

        <b-row class="mb-13">
            <b-col cols="9" class="p-0">
                <label for="nameStandardBook">Введите название книги*</label>
                <b-form-input id="nameStandardBook" v-model="entity.Name" />
            </b-col>
            <b-col>
                <label for="yesno">Статус</label>
                <yes-no-input v-model="entity.IsActive"
                              id="yesno"
                              text-yes='Активный'
                              text-no='Неактивный'>
                </yes-no-input>
            </b-col>
        </b-row>

        <label for="selectTag">Выберите тег</label>
        <custom-multiselect id="selectTag"
                            v-model="entity.TagId"
                            :options="tags"/>
        <hr class="my-4">

        <b-row>
            <b-col cols="3">
                <label class="mt-7">Выберите изображение*</label>
            </b-col>
            <b-col>
                <open-file-dialog v-model="entity.Image" 
                                  accept="image/jpeg,image/png"
                                  :url-file-open="entity.ImageUrl" 
                                  :is-image="true"
                                  @error = "inValidSize" />
            </b-col>
        </b-row>

        <hr class="my-4">

        <b-row>
            <b-col cols="3">
                <label class="mt-7">Выберите файл книги*</label>
            </b-col>

            <b-col cols="9">
                <open-file-dialog v-model="entity.Pdf"
                                  :url-file-open="entity.PdfUrl"  
                                  accept="application/pdf" />
            </b-col>
        </b-row>

        <hr class="my-4">

        <b-row class="m-0">

            <b-col cols="2" class="p-0 mr-10">
			    <b-button block 
                          id="admin-btn-save"
                          class="admin-button"    
                          @click="saveStandardBook">
                    Сохранить
                </b-button>
            </b-col>

            <b-col cols="2" class="p-0">
			    <b-button block v-if="id"
                          id="admin-btn-cancel"
                          class="admin-button" 
                          @click="deleteStandardBookDialog">
                    Удалить
                </b-button>
            </b-col>

		</b-row>


    </b-container>
</template>
<script>

import apiService from '@/services/api.service'
import dialogService from '@/services/dialog.service'

import ApiHeaders from '@/store/models/ApiHeaders'

import AllRoutes from '@/routes/all.routes'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'

import YesNoInput from '@/components/shared/YesNoInput'
import CustomMultiselect from '@/components/shared/CustomMultiSelect'
import OpenFileDialog from '@/components/shared/OpenFileDialog'

import StandardBookEditModel from '@/store/models/admin/standardBooks/StandardBookEdit'

export default {
    computed: {
        header: function() {
            return this.id == null ? "Создание книги" : "Редактирование книги";
        },
        setImage: function() {
            return this.entity.ImageUrl
                        ? this.entity.ImageUrl
                        : "/img/stubImageReference.png";
        }
    },
    data: function() {
        let load = new Loading();

        let apiHeaders = new ApiHeaders().mapToDto(this.$route.query['api-Version']);

        let id = Object.keys(this.$route.query).length 
                    ? this.$route.query.id 
                    : null;
        
        let entity = new StandardBookEditModel().mapFromDto(null);

        this.getStandardBookAndTags(id, load, apiHeaders); 

        return {
            load: load,
            apiHeaders: apiHeaders,
            id: id,
            entity: entity,
            tags: []    
        }
    },
    methods: {
        getStandardBookAndTags: function(id, load, apiHeaders) {
            load.Calculate(true);

            apiService.Admin.StandardBooks.GetAllInfo(apiHeaders)
                .then(response => {
                    this.tags = response.data.SubTags;
                    if(id) {
                        apiService.Admin.StandardBooks.Get(id, apiHeaders)
                            .then(response => {
                                this.entity = new StandardBookEditModel().mapFromDto(response.data);
                                this.entity.TagId = this.tags.find(e => e.Id == this.entity.TagId);
                                load.Calculate(false);
                            })
                            .catch(() => load.Calculate(false));
                    }
                    load.Calculate(false);
                })
                .catch(() => load.Calculate(false)); 
        },
        saveStandardBook: function () {		
            if(this.entity.IsInValid()){
                dialogService.showAlert('Предупреждение', 'Вы не заполнили все обязательные поля или не добавили файл для книги стандартов. Поле "Выберите теги" не является обязательным');
                return;
            }	

            this.load.Calculate(true);
            let standardBook = this.entity.mapToDto();

            apiService.Admin.StandardBooks.PostUpdate(standardBook, this.apiHeaders)
                .then(response => {
                    this.$router.push({ path: AllRoutes.Admin.StandardBooks.Index, query: { 'api-Version': this.apiHeaders['api-Version'] } })})
                .catch(error => this.load.Calculate(false));
        },
        inValidSize: function(content) {
            dialogService.showAlert('Предупреждение', 'Размер изображения не должен превышать 200х200');
        },
        deleteStandardBookDialog: function() {
            if(!this.id)
                return;

            dialogService.showConfirm('Подтверждение удаления', 'Вы действительно хотите удалить данную книгу стандартов?')
                .then(ok => {
                    this.deleteStandardBook(this.apiHeaders);
                })
                .catch(cancel => {});
        },
        deleteStandardBook: function(apiHeaders) {
            apiService.Admin.StandardBooks.PostDelete(this.id, apiHeaders)
                .then(response => {
                    this.$router.push({ path: AllRoutes.Admin.StandardBooks.Index, query: { 'api-Version': this.apiHeaders['api-Version'] } })

                })
                .catch(error => this.load.Calculate(false));
        }
    },
    components: {
        Spinner,
        YesNoInput,
        CustomMultiselect,
        OpenFileDialog
    }
}
</script>